<!-- Translated: yes -->
<template>
  <div class="component" v-if="SITE_CONFIG.modules_open.school.open">
    <div class="info">
      <strong>{{ count }}</strong> {{ $t('general.number-results', {count: ''}) }}
      <button ref="resetButton" class="reset-button reset-filter-text" @click="reset()" v-show="activeFiltersCount > 0">
        {{ $t('general.reset-filter') }} <icon name="Reset" :scale="1.3" />
      </button>
    </div>
    <transition name="animate-filter">
      <div v-if="activeFiltersCount > 0" class="active-filters-list">
        <span class="label">{{ $t('general.picked-filters') }}</span>
        <ul>
          <li v-for="(value, filter) in activeFilters">
            <FilterListItem :filter="filter" :label="value" @click="resetSkiSchoolFilter(filter); emit();" />
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import {
  size,
} from 'lodash/fp';
import FilterListItem from '@/components/parts/Accomodation/List/Filter/FilterListItem';
import { mapMutations } from 'vuex';

import moment from 'moment';

export default {
  props: {
    unitCount: {},
    count: {
      default: 0,
    },
  },
  components: {
    FilterListItem,
  },
  computed: {
    activeFilters() {
      const filters = {};

      /*eslint-disable */
      for (var i in this.SITE_CONFIG.skischool.ages) {
        if (this.$store.state.skiSchoolFilter[this.SITE_CONFIG.skischool.ages[i][1]]) {
          filters[this.SITE_CONFIG.skischool.ages[i][1]] = this.SITE_CONFIG.skischool.ages[i][0];
        }
      }
      for (var i in this.SITE_CONFIG.skischool.levels) {
        if (this.$store.state.skiSchoolFilter[i]) {
          filters[i] = this.SITE_CONFIG.skischool.levels[i];
        }
      }
      /*eslint-enable */

      if (this.$store.state.skiSchoolFilter.date) {
        filters.date = moment(this.$store.state.skiSchoolFilter.date).format('D/M');
      }

      return filters;
    },
    activeFiltersCount() {
      return size(this.activeFilters);
    },
  },
  methods: {
    ...mapMutations([
      'resetSkiSchoolFilter',
    ]),
    emit() {
      this.$nextTick(() => {
        this.$emit('change');
      });
    },
    reset() {
      const $this = this;
      $this.$refs.resetButton.className = 'reset-button animation';
      $this.resetSkiSchoolFilter();
      this.emit();
      setTimeout(() => {
        $this.$refs.resetButton.className = 'reset-button';
      }, 1000);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.component
  transition-slide('animate-filter')

.component
  max-width container-width
  margin-right auto
  margin-left auto
  font-size 14px
  padding-top space-1
  display flex
  justify-content: space-between;

.active-filters-list
  padding-top space-1
  display flex
  align-items center
  position relative
  z-index 1
  padding-left padding-mobile
  padding-right padding-mobile
  +max-mobile()
    display: block;
    width: 100%;
    font-size: 12px
  .label
    font-weight bold
    flex none
    padding-top space-1
    padding-bottom space-1
    position relative
    top -.0625em
    +max-mobile()
      display: block;
      width: 100%
      padding-top: 2px
      padding-bottom: 2px
      line-height: 1.1em

  ul
    display flex
    align-items center
    flex-wrap wrap
    flex auto
    list-style none
    padding 0
    li
      padding-top space-1
      padding-bottom space-1
      padding-left space-2
      +max-mobile()
        padding: 0px 5px 8px 0px

.reset-button
  button-reset()

.reset-filter-text
  &:hover
    border 0px
    text-decoration underline

.reset-button .icon--Reset
  transition: none
.reset-button.animation .icon--Reset
  transform: rotate(360deg);
  transition: all 1s

.info
  display flex
  align-items center
  line-height 2em
  margin-bottom 1em
  padding-top 20px
  +max-tablet()
    margin-left: 10px
  +max-mobile()
    display none

  & > *
    padding-right 7px
    padding-left space-2
    position relative

    &:nth-child(1)
      padding-left 0

    :after
      width 1px
      position absolute
      left 6px
      top -5px
      height 2em
      content ""
      border-right solid 1px rgba(191, 217, 225, 0.5);
    &:nth-child(1) :after
      display none
</style>



// WEBPACK FOOTER //
// SkiSchoolFilterInfo.vue?713c0727